export const emailAlertsConstants = {
  dropDownValues: [
    { value: 'legisCategoryAlerts', label: 'Legislative Alerts by Category' },
    { value: 'legisRecordAlerts', label: 'Legislative Alerts by Record' },
    { value: 'legisComplianceAlerts', label: 'Legislative Compliance Alerts' },
    { value: 'regsCategoryAlerts', label: 'Regulatory Alerts by Category' },
    { value: 'regsRecordAlerts', label: 'Regulatory Alerts by Record' },
    { value: 'regsComplianceAlerts', label: 'Regulatory Compliance Alerts' },
    { value: 'localCategoryAlerts', label: 'Local Legislation Alerts by Category' },
    { value: 'localRecordAlerts', label: 'Local Legislation Alerts by Record' },
    { value: 'customAlerts', label: 'Custom Alerts' }
  ],
  alertsOptionsValues: [
    {
      text: 'Show Bill Progress',
      id: 'billProgress',
      type: 'checkbox'
    },
    {
      text: 'Show Bill History',
      id: 'billHistory',
      type: 'checkbox'
    },
    {
      text: 'Record Access Record from E-mails',
      id: 'accessRecord',
      type: 'checkbox'
    }
  ],
  basicSettings: [
    {
      text: 'Plain Text Email',
      id: 'plainText',
      type: 'checkbox'
    },
    {
      text: 'Send As Attachment',
      id: 'asAttachment',
      type: 'checkbox'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/ManagementEmailAlerts/constants.js